import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { firstName } from '../../../services';
import { stripeConfigSelector } from '../../../state/modules/configuration/selectors';
import { currentUserSelector, userActions } from '../../../state/modules/user';
import Loading from '../loading';

/**
 * Welcome page.
 */
class Welcome extends Component {

  componentDidMount() {
    if (!this.props.user.id) {
      this.props.getUser();
    }
  }

  userFirstName() {
    return firstName(this.props.user) || 'Anonymous';
  }

  render() {
    if (this.props.plans.length === 0 || !this.props.user.id) {
      return <Loading />;
    }

    return (
      <div id='youre-in'>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1 className="text-center">You're in</h1>
              <p>Welcome {this.userFirstName()}! Let's get started by setting up your account.</p>
              <p>
                <LinkContainer className='full large' to={routes.onboarding.afsLicence}>
                  <Button>Set up my account</Button>
                </LinkContainer>
              </p>
              <p>
                <LinkContainer exact className='full' to={routes.app.dashboard}>
                  <Button bsStyle='plain'>I'll do this later – take me to Caddie</Button>
                </LinkContainer>
              </p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  config: stripeConfigSelector(state),
  plans: state.payment.plans,
  user: currentUserSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  getUser: bindActionCreators(userActions.user.getCurrent, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/pages/onboarding/welcome.js